export default __webpack_public_path__ + "static/media/B2B - Preview 2.89caa2b3.png";